import { useEffect, useRef, useState } from "react";
import { useVehicle } from "../../context/VehicleContext";

const API_URL =
  process.env.REACT_APP_API_URL ||
  "https://eleven11-i6v4.onrender.com";

const RECENTS = [
  "RXP-X 300 Supercharger",
  "SVHO Intake Grate",
  "Spark Wear Ring",
];

const POPULAR = [
  "Electrical",
  "Engine",
  "Intake",
  "Exhaust",
  "Pump",
  "Oil",
];

export default function SearchBarDropdownMobile({
  open,
  onClose,
  query,
  onSearch,
}) {
  const panelRef = useRef(null);

  const [results, setResults] = useState([]);
  const [loading, setLoading] = useState(false);

  const {
    selectedVehicle,
    vehicleLoaded,
  } = useVehicle();

  useEffect(() => {
    if (!open) return;

    const handler = (e) => {
      if (
        panelRef.current &&
        !panelRef.current.contains(e.target)
      ) {
        onClose();
      }
    };

    document.addEventListener(
      "mousedown",
      handler
    );

    return () =>
      document.removeEventListener(
        "mousedown",
        handler
      );
  }, [open]);

  useEffect(() => {
    if (!query.trim()) {
      setResults([]);
      return;
    }

    const timeout = setTimeout(async () => {
      try {
        setLoading(true);

        let url =
          `${API_URL}/api/listings/search/query?q=${encodeURIComponent(query)}`;

        if (selectedVehicle) {
          const params = new URLSearchParams({
            manufacturer:
              selectedVehicle.manufacturer,

            model:
              selectedVehicle.model,

            year:
              selectedVehicle.year,
          });

          url += `&${params.toString()}`;
        }

        const res = await fetch(url);

        const data = await res.json();

        setResults(data || []);
      } catch (err) {
        console.error(err);
      } finally {
        setLoading(false);
      }
    }, 250);

    return () => clearTimeout(timeout);
  }, [query]);

  if (!open) return null;

  const styles = {


  curtain: {
  position: "fixed",
  inset: 0,

  background: "rgba(0,0,0,0.12)",

  backdropFilter: "blur(6px)",
  WebkitBackdropFilter: "blur(6px)",

  zIndex: 9997,
},



panel: {
  position: "absolute",

  top: "100%",

left: "16px",
right: "16px",
width: "auto",

  marginTop: "0",

  zIndex: 10000,

  background:
    "rgba(255,255,255,0.94)",

  backdropFilter:
    "blur(30px) saturate(180%)",

  WebkitBackdropFilter:
    "blur(30px) saturate(180%)",

  borderRadius: "0 0 24px 24px",

  overflow: "hidden",

  border:
    "1px solid rgba(255,255,255,0.7)",

  borderTop: "none",

  boxShadow:
    "0 18px 40px rgba(0,0,0,0.10)",

  opacity: open ? 1 : 0,

  transform: open
    ? "translateY(0)"
    : "translateY(-6px)",

  transition: "all 0.22s ease",
},



    body: {
      padding: "18px 16px 24px",

      maxHeight: "72vh",

      overflowY: "auto",
    },

    section: {
      marginBottom: "26px",
    },

    title: {
      fontSize: "13px",

      fontWeight: 700,

      color: "#9CA3AF",

      letterSpacing: "0.06em",

      marginBottom: "14px",
    },

    recentItem: {


      display: "flex",
      alignItems: "center",

      padding: "14px 0",

      borderBottom:
        "1px solid rgba(0,0,0,0.05)",

      background: "none",

width: "100%",

      borderLeft: "none",
      borderRight: "none",
      borderTop: "none",

      textAlign: "left",

      fontSize: "15px",

      fontWeight: 500,

      color: "#111827",
    },

    chips: {
      display: "flex",

      gap: "10px",

      overflowX: "auto",

      paddingBottom: "4px",
    },

    chip: {
      flexShrink: 0,

      padding: "12px 16px",

      borderRadius: "999px",

      background: "#F3F4F6",

      border:
        "1px solid rgba(0,0,0,0.05)",

      fontSize: "14px",

      fontWeight: 600,

      color: "#111827",
    },

    resultsWrap: {
      display: "flex",
      flexDirection: "column",

      gap: "12px",
    },

    resultCard: {
      display: "flex",
      alignItems: "center",

      gap: "12px",

      padding: "12px",

      borderRadius: "18px",

      background: "#fff",

      border:
        "1px solid rgba(0,0,0,0.05)",

      boxShadow:
        "0 4px 14px rgba(0,0,0,0.05)",
    },

    image: {
      width: 64,
      height: 64,

      borderRadius: 12,

      objectFit: "cover",

      background: "#F3F4F6",

      flexShrink: 0,
    },

    resultInfo: {
      flex: 1,

      minWidth: 0,
    },

    resultTitle: {
      fontSize: "14px",

      fontWeight: 700,

      lineHeight: "20px",

      color: "#111827",

      marginBottom: "4px",
    },

    resultSub: {
      fontSize: "12px",

      color: "#9CA3AF",
    },
  };

  return (
    <>
      <div
        style={styles.curtain}
        onClick={onClose}
      />

      <div
        ref={panelRef}
        style={styles.panel}
      >
        <div style={styles.body}>
          {!query.trim() && (
            <>
              <div style={styles.section}>
                <div style={styles.title}>
                  RECENT SEARCHES
                </div>

                {RECENTS.map((item) => (
                  <button
                    key={item}
                    style={styles.recentItem}
                    onClick={() =>
                      onSearch(item)
                    }
                  >
                    {item}
                  </button>
                ))}
              </div>

              <div style={styles.section}>
                <div style={styles.title}>
                  POPULAR CATEGORIES
                </div>

                <div style={styles.chips}>
                  {POPULAR.map((item) => (
                    <button
                      key={item}
                      style={styles.chip}
                      onClick={() =>
                        onSearch(item)
                      }
                    >
                      {item}
                    </button>
                  ))}
                </div>
              </div>
            </>
          )}

          {query.trim() && (
            <div style={styles.section}>
              <div style={styles.title}>
                SEARCH RESULTS
              </div>

              <div style={styles.resultsWrap}>
                {loading ? (
                  <div>
                    Searching...
                  </div>
                ) : results.length > 0 ? (
                  results.map((item) => (
                    <button
                      key={item._id}
                      style={styles.resultCard}
                      onClick={() => {
                        window.location.href =
                          `/product/${item._id}`;
                      }}
                    >
                  <img
                        src={(() => {
                          const variant = item.variants?.find(v => v.condition === "used") || item.variants?.[0];
                          const img = variant?.images?.[0] || item.images?.[0];
                          return img?.startsWith("http") ? img : `${API_URL}/${img}`;
                        })()}
                        style={styles.image}
                      />

                      <div
                        style={
                          styles.resultInfo
                        }
                      >
                        <div
                          style={
                            styles.resultTitle
                          }
                        >
                          {item.title}
                        </div>

                        <div
                          style={
                            styles.resultSub
                          }
                        >
                          {item.partNumber}
                        </div>
                      </div>
                    </button>
                  ))
                ) : (
                  <div>
                    No results found
                  </div>
                )}
              </div>
            </div>
          )}
        </div>
      </div>
    </>
  );
}